import { Link } from "react-router-dom";
import { ArrowLeft, ShieldOff } from "lucide-react";
import { GlassCard } from "@/components/common/GlassCard";
import { Button } from "@/components/ui/button";
import { usePermission } from "@/contexts/AuthContext";
import { APPS_HOME_PATH } from "@/lib/apps";

interface PermissionRouteGateProps {
  resource: string;
  action: string;
  title?: string;
  description?: string;
  children: React.ReactNode;
}

export function PermissionRouteGate({
  resource,
  action,
  title = "Access denied",
  description = "You don't have permission to view this page. Contact your organization owner if you need access.",
  children,
}: PermissionRouteGateProps) {
  const allowed = usePermission(resource, action);

  if (!allowed) {
    return (
      <section className="flex flex-1 items-center justify-center p-6">
        <GlassCard className="w-full max-w-lg text-center">
          <ShieldOff className="mx-auto mb-4 h-12 w-12 text-violet-400" />
          <h1 className="mb-2 text-2xl font-semibold text-white">{title}</h1>
          <p className="mb-6 text-slate-300">{description}</p>
          <Button asChild variant="outline" className="border-white/20 text-white hover:bg-white/10">
            <Link to={APPS_HOME_PATH}>
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Dashboard
            </Link>
          </Button>
        </GlassCard>
      </section>
    );
  }

  return <>{children}</>;
}
